import { useQuery } from '@tanstack/react-query'
import { Statement } from './useAffiliateDashboard'

const API_URL = '/api/affiliate/manager'

export type OverrideStatement = {
    period_start: string | null
    period_end: string | null
    creators: number
    profit: string
    rate: string
    share: string
    /** BR1's take from the cohort this period; the share never exceeds it (D-001). */
    br1_take?: string
    /** The share was lowered to BR1's take (D-001). */
    capped?: boolean
    is_negative_period: boolean
}

export type ManagedCreator = {
    username: string
    joined: string
    signups: number
    profit: string
    creator_share: string
}

export type AffiliateManagerDashboard = {
    username: string
    recruiting_url: string
    creators: ManagedCreator[]
    override: { lifetime: OverrideStatement; current_period: OverrideStatement }
    own: { lifetime: Statement; current_period: Statement }
    funnel: { visits: number; signups: number; active_players: number }
    payouts: Array<{
        period_start: string
        period_end: string
        amount: string
        paid_at: string
        method: string
        reference: string
    }>
}

export const useAffiliateManagerDashboard = () =>
    useQuery<AffiliateManagerDashboard>({
        queryKey: [API_URL],
        queryFn: async () => {
            const res = await fetch(API_URL)
            if (!res.ok) throw new Error('Could not load your manager dashboard.')
            return res.json()
        },
        retry: false,
    })
